import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailQuickFinderComponent } from '../../components/email-quick-finder/email-quick-finder.component';
import { TranslatePipe } from '../../../../core/_pipes/pipes/translate.pipe';
import { HttpClient } from '@angular/common/http';
import { FlagService } from '../../services/flag/flag.service';
import { QuarantineService } from '../../services/quarantine/quarantine.service';
import { StorageService } from 'src/app/core/_services/storage.service';
import { ArchiverService } from '../../services/archiver/archiver.service';
import { EmailTrackerComponent } from '../tracker/tracker.component';
import { EmailArchiverModalComponent } from '../../components/email-archiver-modal/email-archiver-modal.component';

@Component({
  selector: 'app-archiver-tracker',
  templateUrl: './archiver.component.html',
  styleUrls: ['../tracker/tracker.component.scss', './archiver.component.scss'],
})
export class ArchiverTrackerComponent
  extends EmailTrackerComponent
  implements OnInit, OnDestroy {

  @ViewChild('quickFinder') protected _textComponent: EmailQuickFinderComponent;

  constructor(
    protected archiverService: ArchiverService,
    protected _storageService: StorageService,
    protected quarantineService: QuarantineService,
    protected ngbModal: NgbModal,
    protected _http: HttpClient,
    protected _translate: TranslatePipe,
    protected _flagService: FlagService,
  ) {
    super(archiverService, _storageService, quarantineService, ngbModal, _http, _translate, _flagService);
    this.setComponent(EmailArchiverModalComponent);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
